	$(document).ready(function () {
			$('.subscribe-tb').addClass('active-tab');
			$('.one-time-div').addClass('d-none');
			$('.one-time-purchase-tb').on('click', function () {
			$('.subscribe-tb').removeClass('active-tab');
			$('.one-time-purchase-tb').addClass('active-tab');
			$('.one-time-div').removeClass('d-none');
			$('.subscription-div').addClass('d-none');
		});
		$('.subscribe-tb').on('click', function () {
			$('.one-time-purchase-tb').removeClass('active-tab');
			$('.subscribe-tb').addClass('active-tab');
			$('.subscription-div').removeClass('d-none');
			$('.one-time-div').addClass('d-none');
		});
	});



document.addEventListener('click', function (e) {
	const btn = e.target.closest('.custom-cart-btn, .custom-atc-bundle, .custom-cart-btn2, .custom-cart-btn3');
	if (!btn) return;

	e.preventDefault();
	if (btn.classList.contains('loading')) return;

	const variantId = btn.dataset.variantId;
	const planId = btn.dataset.planId;
	if (!variantId) return;

	const originalText = btn.innerHTML;
	btn.classList.add('loading');
	btn.innerHTML = 'Adding...';
	btn.style.pointerEvents = 'none';

	let item = {
		id: variantId,
		quantity: 1
	};

	if (planId) {
		item.selling_plan = planId;
	}

	fetch('/cart/add.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ items: [item] })
	})
		.then(res => {
		if (!res.ok) throw new Error('Add to cart failed');
		return res.json();
		})
		.then(() => {

		// ✅ Dawn / OS 2.0 themes
		const cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer && typeof cartDrawer.open === 'function') {
			cartDrawer.open();
			return;
		}

		const cartIcon =
			document.querySelector('[aria-controls="cart-drawer"]') ||
			document.querySelector('.header__icon--cart') ||
			document.querySelector('a[href="/cart"]');

		if (cartIcon) {
			cartIcon.click();
			return;
		}

		console.warn('Cart drawer not found');
		})
		.catch(err => {
		console.error(err);
		alert('Unable to add product');
		return;
		})
		.finally(() => {
		btn.innerHTML = originalText;
		btn.classList.remove('loading');
		btn.style.pointerEvents = '';
		});
});
